import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDataTable',
})
export class FilterDataTablePipe implements PipeTransform {

  transform(tableData: Array<any>, status: string = "", keyName: string = "", searchValue: string = "" , type: string = "", currentSelectedBeat: any = ""): Array<any> | [] {
    let  filterData: Array<any> = tableData;
    if (Array.isArray(tableData)) {
      if (!type) {
        if (status  && keyName) {
          if (status !== "all" ) {
            if (keyName === "delivery_status") {
              filterData = tableData.filter(item => item[keyName].id === status);
            } else {
              filterData = tableData.filter(item => item[keyName] === status);
            }
          } else {
            filterData = tableData; 
          }
        }
      } else  {
        if (type === "titleSearch") {
          filterData = this.getItemSearchByTitle(searchValue, filterData);
        } else {
          if (currentSelectedBeat) {
            if (currentSelectedBeat.id !== "draft") {
              filterData =  tableData.filter(item => item.id !== 'draft' && item.id !== 'all');
            } else {
              filterData =  tableData.filter(item => item.id === 'draft' && item.id !== 'all');
            }
          }
        }
      }
    }
    if (!type) { 
      filterData = this.getSearchListData(searchValue, filterData);
    }
    return filterData;
  }

  getSearchListData(searchValue: string, filterData: Array<any>): Array<any> {
    let finalFilterData = JSON.parse(JSON.stringify(filterData));
    if (!searchValue) {
      return finalFilterData;
    }
    const lower = searchValue.toLowerCase();
    finalFilterData =  filterData.filter(user =>
      Object.values(user).some((val: any) =>
        val != null && val.toString().toLowerCase().includes(lower)
      )
    );
    return finalFilterData;
  }

  getItemSearchByTitle(searchValue: string, filterData: Array<any>): Array<any> {
    const query = searchValue.trim().toLowerCase();
    if (!query) {
      return filterData;
    }

    return filterData.filter((beat: any) =>
      beat.title?.toLowerCase().includes(query)
    );

  }

}
